import React from 'react';
import Wrapper from '../../Components/Wrapper/wrapper';
import ParentsComponent from '../../Components/parents';
const Parents = () => {
  return (
    <Wrapper header={'Parents'}>
      <ParentsComponent />
    </Wrapper>
  );
};
export default Parents;
